export const Expander = {
  // Make an expander cell
  Header: () => null, // No header
  id: 'expander', // It needs an ID
  width: '5%',
  Cell: ({ row }) => (
    // Use Cell to render an expander for each row.
    // We can use the getToggleRowExpandedProps prop-getter
    // to build the expander.
    <span {...row.getToggleRowExpandedProps()}>
      {/* {row.isExpanded ? '-' : '+'} */}
      {row.isExpanded ? '▼' : '►'}
    </span>
  ),
}